import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {
  fetchListLicenses,
  fetchListLicensesLogs,
  getLicenseDetailByOrg,
  getLicenseDetailByOrgLogs,
  ILicenseItem,
  ListLicenses,
  ListLicensesLogs,
} from 'api/productApi'
import {RootState} from 'store'

export const handleGetListLicenseWithItem = createAsyncThunk(
  'productInstitutionOperationHistory/getListLicenseWithItem',
  async (payload: URLSearchParams, {rejectWithValue}) => {
    try {
      const response = await getLicenseDetailByOrg(payload)
      return response
    } catch (err) {
      return rejectWithValue(err.message)
    }
  },
)

export const handleGetListLicenseLogs = createAsyncThunk(
  'productInstitutionOperationHistory/getListLicenseLogs',
  async (payload: string, {rejectWithValue}) => {
    try {
      const response = await getLicenseDetailByOrgLogs(payload)
      return response
    } catch (err) {
      return rejectWithValue(err.message)
    }
  },
)

interface OrgCanRegisterState {
  loading: boolean
  error: unknown
  // query: OrgCanRegisterParam
  selectedLicense: ILicenseItem | null
  listLicenseWithItem: ListLicenses[] | []
  listActive: ListLicenses[] | []
  listDiscontinued: ListLicenses[] | []
  listLicenseLogs: ListLicensesLogs | null
  // totalPages: number
}

const initialState: OrgCanRegisterState = {
  loading: false,
  error: undefined,
  selectedLicense: null,
  listLicenseWithItem: [],
  listActive: [],
  listDiscontinued: [],
  listLicenseLogs: null,
}

export const productInstitutionOperationHistorySlice = createSlice({
  name: 'productInstitutionOperationHistory',
  initialState,
  reducers: {
    setSelectLicense: (state, action: PayloadAction<ILicenseItem>) => {
      state.selectedLicense = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(handleGetListLicenseWithItem.pending, (state) => {
        state.loading = true
      })
      .addCase(handleGetListLicenseWithItem.fulfilled, (state, action) => {
        state.loading = false
        state.listLicenseWithItem = action.payload.data
        state.listActive = action.payload.data.filter(
          (item) =>
            item.status === 'ACTIVE' &&
            item.deactivationDateTime > new Date().getTime(),
        )
        state.listDiscontinued = action.payload.data.filter(
          (item) =>
            item.status !== 'ACTIVE' ||
            item.deactivationDateTime <= new Date().getTime(),
        )
      })
      .addCase(handleGetListLicenseWithItem.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })

    builder
      .addCase(handleGetListLicenseLogs.pending, (state) => {
        state.loading = true
      })
      .addCase(handleGetListLicenseLogs.fulfilled, (state, action) => {
        state.loading = false
        state.listLicenseLogs = action.payload.data
      })
      .addCase(handleGetListLicenseLogs.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
  },
})

export const {setSelectLicense} =
  productInstitutionOperationHistorySlice.actions

export default productInstitutionOperationHistorySlice.reducer

export const selectLoading = (state: RootState) =>
  state.productInstitutionOperationHistory.loading
export const selectedLicenseData = (state: RootState) =>
  state.productInstitutionOperationHistory.selectedLicense
export const selectError = (state: RootState) =>
  state.productInstitutionOperationHistory.error

export const selectListLicenseWithItem = (state: RootState) =>
  state.productInstitutionOperationHistory.listLicenseWithItem
export const selectListLicenseLogs = (state: RootState) =>
  state.productInstitutionOperationHistory.listLicenseLogs

export const selectListActive = (state: RootState) =>
  state.productInstitutionOperationHistory.listActive
export const selectListDiscontinue = (state: RootState) =>
  state.productInstitutionOperationHistory.listDiscontinued
